import { css } from '@emotion/core';
import { isArray } from 'lodash';
/**
 * Used to hide elements from a react component.
 *
 * Example:
 * import MediaQueries from '../../styles/Grid/MediaQueries';
 *
 * <div css={hideElementCss(MediaQueries.lgAndUp)} />
 * or:
 * <div css={hideElementCss([MediaQueries.sm, MediaQueries.lgAndUp])} />
 *
 * @param {Array || string} queryArg Array of media queries or a single query values from /styles/Grid/MediaQueries.
 * @returns {object} Returns an emotion css object.
 */

const getHideStyles = mediaQuery =>
  css({
    [mediaQuery]: {
      display: 'none',
    },
  });

export const hideElementCss = queryArg =>
  isArray(queryArg)
    ? queryArg.map(mediaQuery => getHideStyles(mediaQuery))
    : getHideStyles(queryArg);

/**
 * Used to show elements from a react component, it also hides the element until query is meeted.
 *
 * Example:
 * import MediaQueries from '../../styles/Grid/MediaQueries';
 *
 * <div css={showElementCss(MediaQueries.lgAndUp, 'flex')} />
 * <span css={showElementCss([MediaQueries.md, MediaQueries.sm])}>
 *
 * @param {Array || string} queryArg Array of media queries or a single query values from /styles/Grid/MediaQueries.
 * @param {string} [displayValue="block"] display optional value for the display property needed then the media condition meets.
 * @returns {object} Returns an emotion css object.
 */

export const getshowStyles = (mediaQuery, displayValue) =>
  css({
    display: 'none',
    [mediaQuery]: {
      display: displayValue,
    },
  });

export const showElementCss = (queryArg, displayValue = 'block') =>
  isArray(queryArg)
    ? queryArg.map(mediaQuery => getshowStyles(mediaQuery, displayValue))
    : getshowStyles(queryArg, displayValue);
